import { render, staticRenderFns } from "./MailEventSearch.vue?vue&type=template&id=fa34e328"
import script from "./MailEventSearch.vue?vue&type=script&lang=js"
export * from "./MailEventSearch.vue?vue&type=script&lang=js"
import style0 from "./MailEventSearch.vue?vue&type=style&index=0&id=fa34e328&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports